export const jgApiUrl = 'https://jgqualifier-api-dev.azurewebsites.net';
export const searchServiceUrl = 'https://devwebservices.bowl.com/USBC.Search.Services';
export const ssoUrl = "https://devsignon.bowl.com";
export const siteUrl = "https://devjuniorgoldqualifier.bowl.com";


// WEBPACK FOOTER //
// ./src/config/settings.Develop.js